(() => {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.source === 'api' || !this.dataset.recommendationsUrl) return;
      this.controller?.abort();
      this.controller = new AbortController();
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.load();
      }, { rootMargin: '400px' });
      this.observer.observe(this);
    }

    async load() {
      this.observer?.disconnect();
      try {
        const response = await fetch(this.dataset.recommendationsUrl, { signal: this.controller.signal });
        if (!response.ok) return;
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const recommended = page.querySelector('product-recommendations[data-source="api"]');
        const content = recommended?.querySelector('[data-recommendations-content]');
        if (!content || this.controller.signal.aborted) return;
        this.querySelector('[data-recommendations-content]')?.replaceWith(content);
        const heading = recommended.querySelector('.merch-heading h2');
        if (heading) this.querySelector('.merch-heading h2').textContent = heading.textContent;
        this.dataset.source = 'api';
        document.querySelector('quick-shop')?.enableButtons(content);
      } catch (error) {
        if (error.name !== 'AbortError') this.dataset.source = 'collection';
      }
    }

    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
})();
